import { styled as biomeStyled } from '@biome-design-system/styles';
import { fromTheme } from '@kyruus/ui-theme';
import Chip from '@kyruus/chip';
import Popover from '@kyruus/popover';
import Cancel from '@kyruus/react-ikons/Cancel';
import Paper from '@kyruus/paper';

export const HorizontalFilterBar = biomeStyled('div')`
  && {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: ${fromTheme('spacing_medium')};
    gap: ${fromTheme('spacing_small')};
    flex-flow: row nowrap;
  }
`;

export const FilterChipWrapper = biomeStyled('div')`
  position: relative;
  width: 100%;
`;

export const FilterChip = biomeStyled(Chip)`
  && {
    font-family: ${fromTheme('font_face')};
    font-size: ${fromTheme('font_size')};
    font-weight: ${fromTheme('font_weight')};
    line-height: ${fromTheme('font_line_height')};
    background-color: ${fromTheme('color_providermatch')}10;
    border: 1px ${fromTheme(
      'border_style'
    )} ${fromTheme('color_providermatch')};
    border-radius: ${fromTheme('border_radius')};
    color: ${fromTheme('color_text')};
    cursor: pointer;

    &:focus {
      outline: 3px solid currentcolor;
      outline-color: #212121;
      outline-offset: -2px;
    }

    &:hover, &:active {
      background-color: rgba(158, 158, 158, 0.1);
    }
  }
`;

export const UnappliedFilterChip = biomeStyled(FilterChip)`
  && {
    font-family: ${fromTheme('font_face')};
    font-size: ${fromTheme('font_size')};
    font-weight: ${fromTheme('font_weight')};
    background-color: white;
    border: 1px ${fromTheme('border_style')} ${fromTheme('color_text')};
    border-radius: ${fromTheme('border_radius')};
    cursor: pointer;
  }
`;

export const UnappliedFilterChipLabel = biomeStyled('span')`
  display: flex;
  align-items: center;

  >svg {
    margin-top: -2px;
  }
`;

export const HorizontalFilters = biomeStyled('div')`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: ${fromTheme('spacing_small')};
  flex-flow: row wrap;
`;

export const RemoveFilterChipIcon = biomeStyled(Cancel)`
  && {
    background: none;
    border: none;
    padding: 0;
    margin-top: -4px;
    color: ${fromTheme('color_text')};
    font-size: ${fromTheme('font_size')};

    &:hover,
    &:focus,
    &:focus-visible,
    &:active,
    &:active:not(:disabled) {
      background: none;
      outline: none;
      color: ${fromTheme('color_text')};
    }
  }
`;

export const FilterChipPopover = biomeStyled(Popover)`
  && .MuiPopover-paper {
    overflow: visible;
  }

  .MuiBackdrop-invisible {
    opacity: 0 !important;
  }
`;

export const FilterTitle = biomeStyled('legend')`
  font-size: ${fromTheme('font_size_heading_5')};
  font-weight: ${fromTheme('font_weight_bold')};
  line-height: ${fromTheme('font_line_height')};
  margin: auto 0;
  padding-left: ${fromTheme('spacing_small')};
`;

export const Filter = biomeStyled(Paper)`
  display: flex;
  width: 360px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 4px;
  background: var(--gray-gray-700, #fff);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25),
    0px 0px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const FilterHeader = biomeStyled('div')`
  display: flex;
  padding: ${fromTheme('spacing_medium')};
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;
